import { render, staticRenderFns } from "./LeadLogs.vue?vue&type=template&id=12c45c62"
import script from "./LeadLogs.vue?vue&type=script&lang=ts"
export * from "./LeadLogs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports